/* ca-view-as.js — "View as" grid/list switch.

   Collection: user-switchable grid/list, remembered in localStorage.
   Search:     locked to list. A 1000-result query is unreadable as tiles, so
               the toggle is hidden and list is forced on every load no matter
               what is stored.

   Writes a data attribute on <html> — never inside #ProductGridContainer,
   which facets.js replaces on every filter change. Purely presentational: no
   cart, quote or pre-order logic touched. */
(function () {
  var ATTR = 'data-ca-view';
  var LOCKED = { search: 'list' };

  /* Scope the stored preference per template.
     The old check read `body.classList.contains('template-search')`, but this
     theme's <body> carries no template class — so Search silently shared the
     Collection key and inherited its view. Scope from the toolbar itself
     (data-scope), falling back to the search template wrapper that
     main-search.liquid always renders. */
  function scope(bar) {
    if (bar && bar.getAttribute('data-scope')) return bar.getAttribute('data-scope');
    if (document.querySelector('.template-search')) return 'search';
    if (document.body.classList.contains('template-search')) return 'search';
    return 'collection';
  }

  function apply(view) {
    document.documentElement.setAttribute(ATTR, view);
    document.querySelectorAll('.ca-viewas__btn').forEach(function (btn) {
      var on = btn.getAttribute('data-view') === view;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function init() {
    var bar = document.querySelector('.ca-viewas');
    var where = scope(bar);

    if (LOCKED[where]) {
      /* Inline style, not [hidden]: .ca-viewas carries display:flex from
         collection.css, which would beat the attribute. */
      if (bar) {
        bar.style.display = 'none';
        bar.setAttribute('aria-hidden', 'true');
      }
      apply(LOCKED[where]);
      return;
    }

    if (!bar) return;
    var stored = null;
    try { stored = localStorage.getItem('ca-view-as-' + where); } catch (e) {}
    apply(stored === 'list' || stored === 'grid' ? stored : (bar.getAttribute('data-default-view') || 'grid'));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ca-viewas__btn');
    if (!btn) return;
    e.preventDefault();
    var where = scope(btn.closest('.ca-viewas'));
    if (LOCKED[where]) return;
    var view = btn.getAttribute('data-view');
    apply(view);
    try { localStorage.setItem('ca-view-as-' + where, view); } catch (err) {}
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Facet AJAX swaps the toolbar markup back in — re-sync the button state.
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function () {
    var view = document.documentElement.getAttribute(ATTR);
    if (view) {
      document.querySelectorAll('.ca-viewas__btn').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-view') === view);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
